import { Reducer } from 'redux';
import { TurnstilesState, TurnstilesTypes } from './types';

const INITIAL_STATE: TurnstilesState = {
  turnstilesList: [],
  error: false,
  loading: false,
};

const reducer: Reducer<TurnstilesState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES LIST TURNSTILES
    case TurnstilesTypes.LIST_TURNSTILES_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        turnstilesList: INITIAL_STATE.turnstilesList,
      };
    case TurnstilesTypes.LIST_TURNSTILES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        turnstilesList: action.payload.turnstilesList,
      };
    case TurnstilesTypes.LIST_TURNSTILES_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        turnstilesList: INITIAL_STATE.turnstilesList,
      };

    default:
      return state;
  }
};

export default reducer;
